export default {
  layout: 'default',
  blocks: [
    {
      module: 'headline',
      headline: "Our Work.",
      byline: "A quick intro blurb that talks about the types of projects we take on, the services we provide and the industries we have deep experinece in.",
    },
    {
      module: 'grid',
      id: 'our-work',
      rows: [
        [
          {
            component: 'component_featuredBlurb',
            itemType: 'work',
            item: 'placeholder1',
            columnStart: 1,
            columnEnd: 7,
          },
          {
            component: 'component_featuredBlurb',
            itemType: 'work',
            item: 'placeholder1',
            columnStart: 9,
            columnEnd: 12,
          },
        ],
        [
          {
            component: 'component_featuredBlurb',
            itemType: 'work',
            item: 'placeholder2',
            columnStart: 1,
            columnEnd: 4,
          },
          {
            component: 'component_featuredBlurb',
            itemType: 'work',
            item: 'placeholder1',
            columnStart: 5,
            columnEnd: 8,
          },
          {
            component: 'component_bigBlockquote',
            quote: "Destroy couch eat and than sleep on your face scratch the furniture damn that dog meow to be let in. Cat not kitten around. Cats are fats I like to pets them they like to meow.",
            author: "Kat Sutton",
            authorTitle: "UX Lead, Particle",
            columnStart: 9,
            columnEnd: 12,
            alignSelf: 'center',
          },
          {
            component: 'component_featuredBlurb',
            itemType: 'work',
            item: 'placeholder1',
            columnStart: 1,
            columnEnd: 4,
          }, {
            component: 'component_featuredBlurb',
            itemType: 'work',
            item: 'placeholder2',
            columnStart: 6,
            columnEnd: 12,
          },
        ],
      ],
    },
    {
      module: 'grid',
      id: 'our-partners',
      rows: [
        [
          {
            component: 'component_sectionHeader',
            title: "Our Partners.",
            byline: "We partner with global brands and wiley start-ups. Working at the cutting edge has its drawbacks. Sometimes it means we can’t share our work for several years. We respect our clients NDAs. Let’s chat about your opportunities. We’d love to talk through some of our relevant work experience.",
            columnStart: 1,
            columnEnd: 7,
          },
        ],
        [
          {
            component: 'component_itemGrid',
            columnStart: 1,
            columnEnd: 12,
            itemsPerRow: 4,
            items: [
              {
                component: 'component_image',
                image: require('@/assets/logos/dreamworks.png'),
              },
              {
                component: 'component_image',
                image: require('@/assets/logos/jaguar.png'),
              },
              {
                component: 'component_image',
                image: require('@/assets/logos/moovel.png'),
              },
              {
                component: 'component_image',
                image: require('@/assets/logos/outcome.png'),
              },
            ],
          },
        ],
      ],
    },
    {
      module: 'contactForm',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/content/work.js